var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"button-search-content"},[_c('file-button-group',{attrs:{"button-array":_vm.buttonArray}}),_c('search')],1),_c('file-table')],1)}
var staticRenderFns = []

export { render, staticRenderFns }